/**
 * @description: 公共函数
 */

/* eslint-disable */


// 交易类型数字字符串转换为中文
export const numToCStr = function (type, numIdList) {
    const typeList = {'SS': '现货', 'CW': '本周', 'NW': '次周', 'CQ': '季度', 'CS': '永续', 'NQ': '次季'};
    var new_numId = {};
    for (var i in numIdList) {
        new_numId[numIdList[i]] = i;
    }
    // console.log(new_numId, numIdList);
    if (new_numId.hasOwnProperty(type)) {
        var type_en = new_numId[type];
        return typeList[type_en];
    } 
    return type;
}

// 任务列表排序 近 -> 远
export const sortTaskList = function (taskList, currencyNum) {
    const typeOrder = ['现货', '永续', '本周', '次周', '季度'];
    if (taskList) {
        var task_len = taskList.length;
        var tmp = null;
        var total_box = {};
        for (let i=0; i<task_len; i++) {// 遍历任务列表
            var last_name,
                next_name = null;
            var i_name = taskList[i].params.currency_type; // 获取当前任务的币种
            if (i !== 0) {// 不是第一个，获取上一个的币种
                last_name = taskList[i-1].params.currency_type;
            }
            if (i < task_len-1) {// 不是最后一个币种，获取下一个币种
                next_name = taskList[i+1].params.currency_type;
            }

            if (i_name == next_name && i_name !== last_name) {
                // 当前币种等于下一个不等于上一个，当前币种为开头，则创建一个列表
                total_box[i_name] = []
            } else if (i_name !== next_name && i_name !== last_name) {
                // 当前币种既不等于上一个也不等于下一个，当前币种只有一个，创建一个列表赋值
                total_box[i_name] = []
                total_box[i_name].push(taskList[i])
            }

            if (i_name == next_name) {
                total_box[i_name].push(taskList[i])
            }
            if (i_name !== next_name && i_name == last_name) {
                total_box[i_name].push(taskList[i])
            }
        }
        var taskTotalList = [];
        for (var t in total_box) {// 遍历每个币种
            var currency_list = total_box[t];
            var currency_list_len = currency_list.length;
            // 对一个币种进行冒泡排序
            for (var i=0; i<currency_list_len-1; i++) {
                var i_a_type = numToCStr(currency_list[i].params.a_transaction_type, currencyNum);
                var i_b_type = numToCStr(currency_list[i].params.b_transaction_type, currencyNum);
                var i_type_list = [i_a_type, i_b_type];
                for(var j=0; j<currency_list_len-1-i; j++) {
                    var j_a_type = numToCStr(currency_list[j].params.a_transaction_type, currencyNum);
                    var j_b_type = numToCStr(currency_list[j].params.b_transaction_type, currencyNum);
                    var j_type_list = [j_a_type, j_b_type];

                    // 获取i下一个的index
                    var next_a_type = numToCStr(currency_list[j+1].params.a_transaction_type, currencyNum);
                    var next_b_type = numToCStr(currency_list[j+1].params.b_transaction_type, currencyNum);
                    var next_type_list = [next_a_type, next_b_type];

                    if (j_type_list.includes('现货') && next_type_list.includes('现货')) {// 两个任务都有现货
                        let c_i_type_list = deepClone(i_type_list);
                        let c_j_type_list = deepClone(j_type_list);
                        let c_next_type_list = deepClone(next_type_list);
                        let i_index = c_i_type_list.indexOf('现货');
                        let next_index = c_next_type_list.indexOf('现货');
                        let j_index = c_j_type_list.indexOf('现货');
                        
                        c_i_type_list.splice(i_index, 1);
                        c_next_type_list.splice(next_index, 1);
                        c_j_type_list.splice(j_index, 1);
                        // 按照索引大小来区分 远近期
                        if (typeOrder.indexOf(c_j_type_list[0]) > typeOrder.indexOf(c_next_type_list[0])) {
                            // i 为远期, 则交换位置
                            tmp = currency_list[j+1];
                            currency_list[j+1] = currency_list[j];
                            currency_list[j] = tmp;
                        }
                    } else if (j_type_list.includes('现货')) {
                        // [taskList[i], taskList[j]] = [taskList[j], taskList[i]]
                    }
                }
            }
            
            for(var k=0; k<currency_list.length; k++) {
                taskTotalList.push(currency_list[k]);
            }
        }
        return taskTotalList;
    }
}

// 深拷贝
export const deepClone = function (arr) {
    var obj = arr.constructor==Array?[]:{};
    for (var i in arr) {
        if (typeof arr[i] === 'object') {
            obj[i] = this.deepClone(arr[i]);
        } else {
            obj[i] = arr[i];
        }
    }
    return obj;
}

// 获取当前时间 
export const getDateTime = function (flag) {
    var date = new Date();
    var year = date.getFullYear();
    var month = date.getMonth()+1;
    var dayDate = date.getDate();
    var hour = date.getHours();
    var minutes = date.getMinutes();
    var seconds = date.getSeconds();
    console.log('dayDate', month);
    if (month > 0 && month < 10) {
        month = '0' + month;
    }
    console.log('dayDate1', month);
    if (dayDate > 0 && dayDate < 10) {
        dayDate = '0' + dayDate;
    } 
    if (hour >= 0 && hour < 10) {
        hour = '0' + hour;
    }
    if (minutes >= 0 && minutes < 10) {
        minutes = '0' + minutes;
    }
    var dateStr = year + '-'+month + '-' + dayDate;
    // if (param == dataStr)
    // return year + '-'+month + '-' + dayDate + ' ' + hour+':'+minutes+':'+seconds;
    if (flag == 'time') {// hour-minutes
        return hour+':'+minutes;
    } 
    
    if (flag == 'date') {// date + hour
        return year+'-'+(month)+'-'+dayDate+' '+ hour+':'+minutes;
    }

    return hour+':'+minutes;
}

// 判断持仓是否为整数
export const isPositionInt = function (param0, param1, currency) {
    let data_0 = Number(param0)
    let data_1 = Number(param1)
    if (currency == 'BTC') {
        // 当币种为 btc 时，除100取整
        var divisor_num = 100
    } else {
        var divisor_num = 10
    }

    if (data_0/divisor_num == data_1/divisor_num) {
        // 相等，表示两边均为整数
        return {
            data: param0,
            status: false
        }
    } else {
        if (Math.round(data_0/divisor_num) == Math.round(data_1/divisor_num)) {
            // 取整后两边相等, 返回整数
            return {
                data: Math.round(data_1/divisor_num)*divisor_num,
                status: false
            }
        } else {
            // 取整后两边不相等，谁是整数返回谁
            if (isInteger(data_0/divisor_num)) {
                return {
                    data: param0,
                    status: true
                }
            } else if (isInteger(data_1/divisor_num)) {
                return {
                    data: param1,
                    status: true
                }
            }
        }
    }
}

// 判断一个数是否为整数
export const isInteger = function (num) {
    if (typeof num == 'number') {
        if (num%1 == 0) return true;
        return false;
    } else {
        console.error('ERROR: Params is not interger in "isInteger" ')
    }
}

// 当前时间-n小时
export const timeReduce = function (dateTime, hour) {
    /**
     * 当前时间-n小时
     * @dateTime: 传入时间，格式: 2012-12-12 00:00
     * @hour: 减去的时间，格式：Number
     * return: 日期时间字符串，格式：2012-12-12/00_00
     */
    let new_time = new Date(dateTime);
    new_time.setHours(new_time.getHours() - hour);
    return new_time.format("yyyy-MM-dd/hh_mm");
}

Date.prototype.format = function (fmt) {
    var o = { 
        "M+" : this.getMonth()+1,                 //月份 
        "d+" : this.getDate(),                    //日 
        "h+" : this.getHours(),                   //小时 
        "m+" : this.getMinutes(),                 //分 
        "s+" : this.getSeconds(),                 //秒 
        "q+" : Math.floor((this.getMonth()+3)/3), //季度 
        "S"  : this.getMilliseconds()             //毫秒 
    }; 
    if(/(y+)/.test(fmt)) {
            fmt=fmt.replace(RegExp.$1, (this.getFullYear()+"").substr(4 - RegExp.$1.length)); 
    }
     for(var k in o) {
        if(new RegExp("("+ k +")").test(fmt)){
             fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
         }
     }
    return fmt; 
}

// 获取当前时间前后的日期时间
export const getDateRecent = function (dateTime, count) {
    var this_date = new Date(dateTime);
    this_date.setDate(this_date.getDate()+count);
    return this_date.format("yyyy-MM-dd hh:mm");
};

// 判断一个变量是否为数组
export const isArray = function (arr) {
    return Object.prototype.toString.call(arr) == '[object Array]';
}